import { ContactService } from './contact';
import { PageService } from './page';
import { DetailService } from './websiteDetails';

export const api = {
	contact: ContactService,
	page: PageService,
	details: DetailService,
};
